export default [
  {
    title: 'Visa',
    name: 'visa',
  },
  {
    title: 'Mastercard',
    name: 'mastercard',
  },
  {
    title: 'Google',
    name: 'google',
  },
  {
    title: 'Apple',
    name: 'apple-black',
  },
  {
    title: 'Apple pay',
    name: 'pay',
  },
];
